export const environment = {
    apiBaseURL: "https://aidishappservices.azurewebsites.net",
    liveChatId: "97f6b8ec-da23-4a33-b897-d159395830e8",
    production: true,
    b2BAuthClientId: '8c18bc08-2e94-498e-a609-f5e81ea55ac0',
    crowdinHashKey: 'e-56fdae3a9e869721061b3b3ftr',
    elasticAPM: {
    elasticServiceName: 'DishIQDigitalBundleService',
    elasticServerUrl: 'https://231426ea0b784324aa2a5747fcae8dc6.apm.eastus2.azure.elastic-cloud.com:443',
    environment: 'PROD',
    distributedTracingOrigins: ['https://aidishappservices.azurewebsites.net'],
    serviceVersion: '1.0.0',
    propagateTracestate: true
  }
};